<template>
    <div class="users-style">
        
        <ul class="list-group mb-3 " v-if='errormsg'>           
            <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
        </ul>
        {{successmsg}}            
            
        
        <b-form @submit.stop.prevent="onSubmit">

            <b-form-group id="name-group" label="Name" label-for="name">
                <b-form-input id="name" name="name" v-model="fdata.name" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group id="email-group" label="Email" label-for="email">
                <b-form-input id="email" name="email" type="email" v-model="fdata.email" v-validate="{ required: true, min: 3 , email:true}" :state="validateState('email')" aria-describedby="email-feedback" data-vv-as="Email"></b-form-input>
                <b-form-invalid-feedback id="email-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group id="phone-group" label="Phone" label-for="phone">
                <b-form-input id="phone" name="phone" v-model="fdata.phone" v-validate="{ required: true, min: 11 }" :state="validateState('phone')" aria-describedby="phone-feedback" data-vv-as="Phone"></b-form-input>
                <b-form-invalid-feedback id="phone-feedback">{{ veeErrors.first('phone') }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group id="user_level-group" label="Access Level" label-for="user_level">
                <b-form-select id="user_level" name="user_level" v-model="fdata.user_level" v-validate="{ required: true }" :options="user_level" :state="validateState('user_level')" aria-describedby="user_level-feedback" data-vv-as="Access Level"></b-form-select>
                <b-form-invalid-feedback id="user_level-feedback">{{ veeErrors.first('user_level') }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group id="password-group" label="Password" label-for="password">
                <b-form-input id="password" name="password" type="password" v-model="fdata.password" v-validate="{ required: true, min: 8 }" :state="validateState('password')" aria-describedby="password-feedback" data-vv-as="Password"></b-form-input>
                <b-form-invalid-feedback id="password-feedback">{{ veeErrors.first('password') }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group id="password_confirmation-group" label="Confirm Password" label-for="password_confirmation">
                <b-form-input id="password_confirmation" name="password_confirmation" type="password" v-model="fdata.password_confirmation" v-validate="{ required: true, confirmed: fdata.password }" :state="validateState('password_confirmation')" aria-describedby="password_confirmation-feedback" data-vv-as="Confirm Password"></b-form-input>
                <b-form-invalid-feedback id="password_confirmation-feedback">{{ veeErrors.first('password_confirmation') }}</b-form-invalid-feedback>
            </b-form-group>


            <b-button type="submit" variant="primary">Submit</b-button>
        </b-form>


                

    </div>
</template>
 
<script>
    export default{
        
        mounted() {
            console.log('login form info started..');   
            //console.log(this.data);  
        },
        data(){            
            
            return {
                                   
                successmsg:'',
                errormsg:[],
                fdata: {email: null, password:null , user_level:null },
                user_level: [
                    { value: null, text: "Select..." },
                    { value: "1", text: "Super Admin" },
                    { value: "2", text: "Admin" },
                    { value: "3", text: "Manager" },
                    { value: "4", text: "Officer" },
                ],
                
            }
        },
        methods:{
            
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
                this.fdata = {
                    
                    //asd:null,
                };

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            onSubmit(e) 
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    e.preventDefault();  
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }                 

                    let formData = new FormData();
                    
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);                    
                        console.log(`${key}: ${value}`);
                    } 

                    axios.post(this.$api_url+'/new-admin', formData, config)
                                .then(function (response) 
                                {
                                    //console.log(response.data);                                
                                    //window.location.href = this.$api_url;
                                    this.successmsg = 'Successfully created!';
                                    
                                }.bind(this))
                                .catch(function (error) 
                                {
                                    currentObj.errormsg = error.response.data.errors;
                                });
                });
            }

        },
        created: function(){
            //
        }
    }
</script>